// extracted by mini-css-extract-plugin
export default {"custAcc_Appoint":"CustomerAppointments_custAcc_Appoint__ssKjp","custAcc_Appoint_List":"CustomerAppointments_custAcc_Appoint_List__UjFIM"};